import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { get } from '../../../server/actions'
import logo from '../../../assets/img/logo1.png'
import PropTypes from 'prop-types'

class superAdminHeader extends Component {
    constructor(props) {
        super(props)
    }
    onLogoutClick = () => {
        get('/logout?access_token=').then(response => {
            if (!response.ok || response.ok) {
                sessionStorage.clear();
                window.location.replace('/login');
            }
        }).catch(ex => {
            sessionStorage.clear();
            window.location.replace('/login');
        })
        sessionStorage.clear();
        window.location.replace('/login');
    };

    render() {

        return (
            <header id="pageTop" className="header-wrapper">

                <div className="container-fluid color-bar top-fixed clearfix">
                    <div className="row">
                        <div className="col-sm-1 col-xs-2 bg-color-1">fix bar</div>
                        <div className="col-sm-1 col-xs-2 bg-color-2">fix bar</div>
                        <div className="col-sm-1 col-xs-2 bg-color-3">fix bar</div>
                        <div className="col-sm-1 col-xs-2 bg-color-4">fix bar</div>
                        <div className="col-sm-1 col-xs-2 bg-color-5">fix bar</div>
                        <div className="col-sm-1 col-xs-2 bg-color-6">fix bar</div>
                        <div className="col-sm-1 bg-color-1 hidden-xs">fix bar</div>
                        <div className="col-sm-1 bg-color-2 hidden-xs">fix bar</div>
                        <div className="col-sm-1 bg-color-3 hidden-xs">fix bar</div>
                        <div className="col-sm-1 bg-color-4 hidden-xs">fix bar</div>
                        <div className="col-sm-1 bg-color-5 hidden-xs">fix bar</div>
                        <div className="col-sm-1 bg-color-6 hidden-xs">fix bar</div>
                    </div>
                </div>
                <nav id="menuBar" className="navbar navbar-default lightHeader">
                    <div className="container">
                        <div className="navbar-header">
                            <button type="button" className="navbar-toggle" data-toggle="collapse"
                                data-target="#navbar">
                                <span className="icon-bar" />
                                <span className="icon-bar" />
                                <span className="icon-bar" />
                            </button>
                            <Link className="navbar-brand" id="brand" to="/superAdmin"><img className="super-admin-logo"
                                src={logo} alt="" /></Link>
                        </div>
                        <div className="navbar-collapse collapse" id="navbar">
                            <ul className="nav navbar-nav navbar-right" style={{ height: 'auto' }}>
                                <li className=" dropdown color-1 active ">
                                    <Link to="/superAdmin" role="button" aria-haspopup="true" aria-expanded="false"><i
                                        className="fa fa-home bg-color-1" aria-hidden="true" /> <span>Home</span></Link>
                                </li>
                                <li className=" dropdown megaDropMenu color-2 ">
                                    <a href="javascript:void(0)" className="dropdown-toggle" data-toggle="dropdown"
                                        data-hover="dropdown" aria-haspopup="true" data-delay="300"
                                        data-close-others="true" aria-expanded="false">
                                        <i className="fa fa-server bg-color-2" aria-hidden="true"></i>
                                        <span>Manage</span>
                                    </a>
                                    <ul className="row dropdown-menu">
                                        <li className="col-sm-2 col-xs-6">
                                            <ul className="list-unstyled">
                                                <li>School</li>
                                                <li className=""><Link to="/superAdmin/schools">Schools</Link></li>
                                                <li className=""><Link to="/superAdmin/schoolList">Manage Schools</Link></li>
                                                <li className=""><Link onClick={this.props.editSchool.bind(this, '', "NEW")} to="/superAdmin/regSchool">Onboard School</Link></li>

                                            </ul>
                                        </li>
                                        <li className='col-sm-2 col-xs-6'>
                                            <ul className="list-unstyled">
                                                <li>Caterer</li>
                                                <li className=""><Link to="/superAdmin/catererList">Manage Caterers</Link></li>
                                                <li className=""><Link to="/superAdmin/catererRecord" onClick={() => {
                                                    this.props.editCaterer.bind(this, '', "NEW");
                                                }}>Onboard Caterer</Link></li>
                                            </ul>
                                        </li>
                                        <li className='col-sm-2 col-xs-6'>
                                            <ul className="list-unstyled">
                                                <li>District</li>
                                                <li className=""><Link to="/superAdmin/districtList">Manage District</Link></li>
                                                <li className=""><Link to="/superAdmin/districtRecord" onClick={() => {
                                                    this.props.editDistrict.bind(this, '', "NEW");
                                                }}>Onboard District</Link></li>
                                            </ul>
                                        </li>
                                        <li className='col-sm-2 col-xs-6'>
                                            <ul className="list-unstyled">
                                                <li>Leads</li>
                                                <li className=""><Link to="/superAdmin/leadManagment">Lead Management</Link></li>
                                            </ul>
                                        </li>
                                        <li className='col-sm-2 col-xs-6'>
                                            <ul className="list-unstyled">
                                                <li>Support</li>
                                                <li className=""><Link to="/superAdmin/supportManagment">Support Management</Link></li>
                                                <li><Link to="/superAdmin/broadcastMsg">Broadcast Messages</Link></li>
                                                <li><Link to="/superAdmin/studentSearch">Student Search</Link></li>
                                                <li><Link to="/superAdmin/pending-transactions">Stripe Transactions</Link></li>
                                            </ul>
                                        </li>
                                        <li className='col-sm-2 col-xs-6'>
                                            <ul className="list-unstyled">
                                                <li>Subscriptions</li>
                                                <li className=""><Link to="/superAdmin/subscription">Manage Subscriptions</Link></li>
                                            </ul>
                                        </li>
                                    </ul>
                                </li>
                                <li className=" dropdown singleDrop color-4">
                                    <a href="javascript:void(0)" className="dropdown-toggle" data-toggle="dropdown"
                                        role="button" aria-haspopup="true" aria-expanded="false"><i
                                            className="fa fa-user bg-color-4" aria-hidden="true" /> <span>Account</span></a>
                                    <ul className="dropdown-menu dropdown-menu-right">
                                        <li><Link to="/superAdmin/accountDetails"> <i
                                            className="fa fa-info-circle" /> Account
                                            details
                                        </Link></li>
                                        <li>
                                            <a href="javascript:void(0);" onClick={this.onLogoutClick.bind(this)}> <i
                                                className="fa fa-power-off" /> Logout </a></li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                </nav>
            </header>

        )
    }
}

superAdminHeader.contextTypes = {
    router: PropTypes.object.isRequired
}

export default superAdminHeader;



// WEBPACK FOOTER //
// ./src/components/SuperAdmin/Home/superAdminHeader.jsx